<template>
  <div style="display:inline;">
    <v-btn
    style="margin-left:0; margin-right:0;"
    flat
    :block="$vuetify.breakpoint.xsOnly"
    color="error"
    @click="removeJob(jobId)">delete</v-btn>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import Confirm from '@/components/Shared/Confirm'

export default {
  components: {
    Confirm
  },
  props: {
    jobId: {
      type: String,
      required: true
    },
    listId: {
      type: Number,
      required: true
    }
  },
  methods: {
    async removeJob (jobId) {
      if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
        const listId = this.listId
        // delete the job
        this.$store.dispatch('removeJob', { listId, jobId })
        // emit job deleted
        this.$emit('job-deleted')
      }
    }
  }
}
</script>
